import React, { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";
import { MdAdd, MdDelete } from "react-icons/md";
import axios from "axios";
import { Link } from "react-router-dom";
import {
  useGetDamagesQuery,
  useRemoveDamageMutation,
} from "../../features/api/damageApi";
import { toast } from "react-toastify";
import { useGetCategoryQuery } from "../../features/api/categoryApi";
import { useGetSubCategoryQuery } from "../../features/api/subcategoryApi";
import { useGetProductQuery } from "../../features/api/productApi";

const DamageProduct = () => {
  const { data: cat } = useGetCategoryQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const categories = cat?.categories;

  const { data: subCategory } = useGetSubCategoryQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const subCategories = subCategory?.subcategories;

  const { data: pro } = useGetProductQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const products = pro?.products;

  const { data, error, isLoading } = useGetDamagesQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const damages = data?.damage_product;

  const [removeDamage] = useRemoveDamageMutation();

  const handleDelete = async (id) => {
    const confirm = window.confirm("Are Your Sure?");
    if (confirm) {
      try {
        const result = await removeDamage(id);
        if (result) {
          toast.success("Delete Success..!!!");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className="p-4">
      <div className="flex justify-between items-center my-4 px-12">
        <h1 className="text-xl font-bold">Damage Product List</h1>
        <Link to={"/dashboard/create-damage"}>
          <MdAdd className="text-2xl text-white bg-blue-500 font-bold cursor-pointer" />
        </Link>
      </div>
      <div className="h-[75vh] overflow-auto max-w-sm lg:max-w-[960px] m-auto">
        {isLoading ? (
          <div className="w-fll h-screen flex flex-col items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          </div>
        ) : damages?.length === 0 ? (
          <p className=" text-xl text-red-500 mt-20 ml-20">
            There are no damage products
          </p>
        ) : (
          <TableContainer component={Paper}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <span className="font-bold">Sl No.</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Category</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Brand</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Product</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Quantity</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Warehouse</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Action</span>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {damages
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((row, i) => {
                    const cat = categories?.find(
                      (cat) => cat?.id === row?.category
                    );
                    const subCat = subCategories?.find(
                      (sCat) => sCat?.id === row?.sub_cat
                    );
                    const product = products?.find(
                      (pro) => pro?.id === row?.pro_name
                    );
                    return (
                      <TableRow key={row?.id}>
                        <TableCell>{i + 1}</TableCell>
                        <TableCell>{cat?.cat_name}</TableCell>
                        <TableCell>{subCat?.sub_catName}</TableCell>
                        <TableCell>{product?.product_name}</TableCell>
                        <TableCell>{row?.quantity}</TableCell>
                        <TableCell>{row?.warehouse}</TableCell>
                        <TableCell className="">
                          <div className="flex items-center gap-x-4">
                            {/* <UpdateProduct product={row} /> */}
                            <span onClick={() => handleDelete(row?.id)}>
                              <MdDelete className="text-xl text-red-500 font-bold cursor-pointer" />
                            </span>
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[20, 30, 50]}
              component="div"
              count={damages?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        )}
      </div>
    </div>
  );
};

export default DamageProduct;